const gtmConfig = {
  gtmId: 'GTM-KJRTV5XD',
  events: {
    pageView: 'pageview',
    click: 'click',
    formSubmit: 'form_submit'
  },
  dataLayer: {
    platform: 'web'
  }
};

export default gtmConfig;